export default __webpack_public_path__ + "static/close_quote-49e8b98bf888d19737bbdcd12aeab741.svg";